<div class="tile__status" data-testid="tile"
    [ngClass]="{ 'tile__status--active': tile.params.workingStatus,
        'tile__status--inactive': !tile.params.workingStatus }">
    <div [ngSwitch]="tile.params.iconId">
        <div *ngSwitchCase="9">
            <svg-icon src="/assets/img/icons/firing_up.svg"
                 *ngIf="!tile.params.workingStatus">
            </svg-icon>
            <svg-icon src="/assets/img/icons/firing_up_active.svg"
                 *ngIf="tile.params.workingStatus">
            </svg-icon>
        </div>
        <div class="icon-wrapper" *ngSwitchCase="17">
            <svg-icon src="/assets/img/icons/pump.svg"
                 *ngIf="!tile.params.workingStatus">
            </svg-icon>
            <svg-icon src="/assets/img/icons/pump_active.svg"
                [class]="'rotate'"
                *ngIf="tile.params.workingStatus">
            </svg-icon>
        </div>
        <div class="tile__svg--feeder-wrapper" *ngSwitchCase="101">
            <svg-icon src="/assets/img/icons/feeder.svg"
                *ngIf="!tile.params.workingStatus">
            </svg-icon>
            <svg-icon src="/assets/img/icons/feeder_active.svg"
                 *ngIf="tile.params.workingStatus">
            </svg-icon>
        </div>
        <div *ngSwitchDefault class="tile__svg--other-wrapper bg-img">
            <img class="tile__svg--other"
                 ngSrc="{{icon.setIcon(tile.params.iconId)}}"
                 width="50" height="50" alt="" />
        </div>
    </div>
    <floating-subtitle class="tile__subtitle"
                       [text]="subtitle(tile.params.txtId)">
    </floating-subtitle>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
            width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
</div>
